import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { MatSelectChange } from '@angular/material/select'

import { I18nService, LgType } from '../../../services/prod/i18n.service'

type MonthType = {
  id: number
  title: string
  count: number
}

@Component({
  selector: 'bmcore-month-select',
  templateUrl: './bmcore-month-select.component.html',
  styleUrls: ['./bmcore-month-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreMonthSelectComponent implements OnInit {
  @Input() currentMonthId: number
  @Output() changeCurrentMonthIdEvent = new EventEmitter<number>()

  lg: LgType
  months: MonthType[] = []

  constructor(private i18nService: I18nService) {}

  ngOnInit(): void {
    this.lg = this.i18nService.getLanguageForPage()

    this.months = [
      { id: 1, title: this.lg.subscriptionBlock.select1, count: 1 },
      { id: 2, title: this.lg.subscriptionBlock.select2, count: 3 },
      { id: 3, title: this.lg.subscriptionBlock.select3, count: 12 },
      { id: 4, title: this.lg.subscriptionBlock.select4, count: 36 }
    ]
  }

  changeCurrentMonth(matEvent: MatSelectChange) {
    this.changeCurrentMonthIdEvent.emit(matEvent.value)
  }
}
